import Http from "./base-http";

class TaskCategory extends Http {
  deleteTaskCategory(id) {
    return this.destroy(id);
  }
  addTaskCategory(data) {
    return this.client.post('/',data)
  }
  updateTaskCategory(id,data) {
    return this.client.put(`/${id}`,data)
  }
}

const taskCategoryObj = new TaskCategory({
  modelUrlPrefix : "TaskCategory"
});

export default taskCategoryObj;